import React from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { ImportIconBadge } from '@/components/icons/ImportIconBadge';
import { ClaimsIcon } from '@/components/icons/ClaimsIcon';
import { ClaimsImportPage } from './ClaimsImportPage';

export const claimsRoutes = [
	{
		// In the side nav's Import section (claimsNavItem)
		path: 'import/claims',
		element: <ClaimsImportPage />,
		handle: {
			title: 'Import claims',
			// The side nav's icon (with the import arrow), at the header's size
			icon: (
				<ImportIconBadge>
					<ClaimsIcon width='40px' height='40px' bgColor='transparent' color='currentColor' />
				</ImportIconBadge>
			),
		},
	},
	{
		// The page's old address
		path: 'claims/import',
		element: <Navigate to={`${paths.admin}/import/claims`} replace />,
	},
];

export const claimsNavItem = {
	text: 'Claims',
	icon: (
		<ImportIconBadge>
			<ClaimsIcon width='30px' height='30px' bgColor='transparent' />
		</ImportIconBadge>
	),
	link: `${paths.admin}/import/claims`,
};
